import type { EditablePermissionKey } from "@mtform/shared";
import { useAuth } from "./AuthContext";

// =============================================================================
// useHasPermission
//
// Reads the current user's effective permission flags (shipped on the
// session by the server) to gate UI — routes, nav tabs, action buttons.
// Super-admins always pass. Unauthenticated or missing-map → false.
//
// This is UI convenience only; every gated action is also enforced on
// the server, so a stale or tampered client can't actually do anything
// it shouldn't.
// =============================================================================

export function useHasPermission(key: EditablePermissionKey): boolean {
  const { state } = useAuth();
  if (state.status !== "authenticated") return false;
  if (state.user.role === "super_admin") return true;
  return Boolean(state.user.permissions?.[key]);
}
